<style>
    .loading-input-container {
        width: 100%;
    }

    .postcode-search {
        border-bottom-right-radius: 5px!important;
        border-top-right-radius: 5px!important;
        text-transform:none!important;
    }

    .address-results {
        background-color: white;
        color:black;
        width: 439px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        margin-top: -3px;
        padding-top: 9px;
        position: absolute;
        z-index: -1;
        height: 300px;
        overflow: scroll;
    }

    .address-results ul {
        list-style: none;
        padding-left: 0px;
    }

    .address-results ul li {
        padding-left: 10px;
        margin-bottom: 0!important;
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 11px;
    }

    .address-results ul li span {
        font-weight: bold;
        margin-right: 8px;
    }

    .address-results ul li:hover {
        background-color: whitesmoke;
        cursor: pointer;
        color: #5bc0de;
    }
</style>

<template>
    <div class="form-group">
        <div class="input-group">
            <div class="loading-input-container">
                <div class="loading-message" v-if="checkingAddress">Checking Address</div>
                <input
                        class="form-control postcode-search"
                        :class="{'is-loading': checkingAddress, 'is-invalid': error}"
                        :disabled="checkingAddress"
                        placeholder="Start typing your address"
                        type="text"
                        v-model="address"
                        v-on:keyup="addressWatcher"
                />
            </div>
        </div>
        <div class="address-results" v-if="loqateAddresses.length > 0 && !checkingAddress">
            <ul>
                <li v-for="address in loqateAddresses" :key="address.id" @click="addressSelected(address)">
                    <span>{{ address.text }}</span> {{ address.description}}
                </li>
            </ul>
        </div>

        <!-- Error modal -->
        <b-modal
                body-class="p-0"
                cancel-disabled
                hide-footer
                id="error-modal"
                title="">
            <div class="modal-body modal-body-lg pt-0">
                <div>
                    <animated-error class="mx-auto mb-4"></animated-error>
                </div>
                <h4 class="text-center mb-4">{{ error }}</h4>
                <p class="text-center">
                    <button @click="$bvModal.hide('error-modal')" class="btn btn-outline-dark">{{ $t('bp.closeButton') }}</button>
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "LandingPageAddressSearch",
        data() {
            return {
                checkingAddress: false,
                error: null,
                address: null
            }
        },

        computed: {
            ...mapGetters([
                'carrierDetails',
                'loqateAddresses',
                'loqateAddress',
                'loqateLatitude',
                'loqateLongitude',
                'onlyOfferSamsung'
            ])
        },

        methods: {
            ...mapActions([
                'findAddress',
                'loadTypes',
                'selectMake',
                'setBookingAddress',
                'retrieveLoqateAddress',
                'loqateGeocode'
            ]),

            addressWatcher() {
                this.findAddress({
                    text: this.address,
                    containerId: null
                });
            },

            headToNextPage() {
                if (this.onlyOfferSamsung) {
                    this.selectMake({
                        id: 2
                    }).then(() => {
                        this.loadTypes();
                        this.$router.push({name: 'deviceType'});
                    });
                    return
                }

                this.$router.push({name: 'deviceMake'});
            },

            addressSelected(address) {
                if (address.id_can_be_used_with_retrieve) {
                    this.checkingAddress = true;

                    this.retrieveLoqateAddress(address)
                        .then((response) => {
                          this.loqateGeocode(response.label.replace(/\n/g, ', '))
                                .then(() => {

                                    let town = this.loqateAddress.district;
                                    if (!town) {
                                        town = this.loqateAddress.city;
                                    }
                                    if (!town) {
                                        town = "Not Set";
                                    }

                                    const requestParams = {model_version_id: this.model_version_id, problems: this.problems};

                                    this.setBookingAddress({
                                        line_1: this.loqateAddress.line_1,
                                        line_2: this.loqateAddress.line_2,
                                        town: town,
                                        postcode: this.loqateAddress.postal_code,
                                        latitude: this.loqateLatitude,
                                        longitude: this.loqateLongitude,
                                        requestParams: requestParams
                                    }).then(() => {
                                        this.headToNextPage();
                                    })
                                    .catch(error => {
                                        this.checkingAddress = false;
                                        this.error = error.response.data.messages[0];
                                        this.$bvModal.show("error-modal")
                                    })

                                });
                        });
                    return;
                }

                this.findAddress({
                    text: this.address,
                    containerId: address.id
                });
            }
        }
    }
</script>

<style scoped>

</style>